import { useQuery } from "@tanstack/react-query";
import { ArchiveConfig } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const useSnapshotArchivingDefaults = () => useQuery({
  queryKey: ["snapshotArchivingDefaults"],
  queryFn: () => defaultOnError(
    ArchiveConfig.snapshotArchivingDefaults(),
    "Loading snapshot archiving defaults failed with status",
    "Could not load snapshot archiving defaults."
  ),
  staleTime: 6e4
});
export default useSnapshotArchivingDefaults;
